<template>
  <div>
    <div class="table-title">
      <span style="text-transform: capitalize">{{`${$tc(selectedObject.type,1)} ${selectedObject.index} | ${$tc('Floorbox',2)}`}}</span>
    </div>
    <v-data-table
      dense
      hide-default-footer
      disable-sort
      :headers="headers"
    >
      <template v-if="!actionTypeIsView" v-slot:header.addButton>
        <thead>
          <th style="padding-left: 30%">
            <v-btn x-small depressed class="add-button" @click="openDialog">
              <v-icon color="#4fa2b7">add_box</v-icon>
            </v-btn>
          </th>
        </thead>
      </template>
      <template v-slot:body>
        <tbody>
          <tr v-for="(item, itemIndex) in floorboxs" :key="itemIndex" class="cursor-pointer">
            <td
              v-for="header in headers"
              :key="header.value"
              :title="item[header.value]"
              :class="header.value"
              :style="{ padding: header.text === '' ? '4px' : '0 0 0 18px' }"
            >
              <div
                v-if="header.value === 'floorbox_label' && !!item[header.value]"
                class="floorbox-icon"
                :style="{ 'background-color': item.floorbox_color }"
                style="margin-right: 5px;"
              />
              <span v-if="header.text === $tc('Floor',1)">{{ getFloorNumber(item[header.value]) }}</span>
              <span v-else-if="header.text === $t('Column')">{{ getColumnIndex(item[header.value],columns) }}</span>
              <span v-else-if="header.text === $t('Cable-inReference')">{{getCableInReference(item[header.value])}}</span>
              <span v-else>{{  item[header.value] }}</span>
              <div
                v-if="header.text === ''"
                class="floorbox-icon"
                :style="{ 'background-color': item.color }"
              />

              <div v-else-if="header.text === 'Active'">
                <v-simple-checkbox v-model="item.active" disabled />
              </div>

              <div v-else-if="!header.text">
                <app-datatable-action-buttons
                  :has-closure="!!item.closure"
                  :is-floorbox="true"
                  :user-can-edit="true"
                  @edit="editItem(item, itemIndex)"
                  :user-can-delete="true"
                  @delete="askConfirmationToDeleteItem(item)"
                  @open-floorbox="openFloorboxTab(item)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:no-data>
        <div v-if="loading" />
      </template>
    </v-data-table>

    <planning-details-table-buttons
      :object-type="selectedObject.type"
      :action-type="actionType"
      @delete-item="askConfirmationToDeleteItem(selectedObject)"
    />

    <app-dialog-box
      :open="deleteDialog"
      :title="$t('DeleteItem')"
      :content="$t('DeleteConfirmation') + '?'"
      :main-action-label="$t('No')"
      @mainAction="closeDeleteDialog"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="deleteItem"
    />
    <floorbox-form
      v-if="floorboxFormIsOpen"
      :dialog-is-open="floorboxFormIsOpen"
      :object-to-edit="itemToEdit.data"
      :floorbox-colors="floorboxColors"
      :floors="[...groundFloors, ...undergroundFloors]"
      :columns="columns"
      :technical-locals="technicalLocals"
      :selectedObject="selectedObject"
      :cableTypeSixOptions="cableTypeSixOptions"
      :cableTypeFiveOptions="cableTypeFiveOptions"
      @close-dialog="closefloorboxForm"
      @create-floorbox="$emit('create-floorbox', $event)"
      @edit-floorbox="saveObject($event)"
    />
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { mapActions } from "vuex";
import PlanningDetailsTableButtons from "./PlanningDetailsTableButtons";
import FloorboxForm from "./FloorboxForm";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { verticalMixin } from "@/mixins/verticalMixin.js";
export default {
  name: "FloorboxesTable",

  components: {
    PlanningDetailsTableButtons,
    AppDatatableActionButtons,
    AppDialogBox,
    FloorboxForm,
  },

  mixins: [managementDatatableMixin, verticalMixin],

  props: {
    selectedObject: {
      type: Object
    },
    floorboxColors: {
      type: Array
    },

    actionType: {
      type: String
    },
    groundFloors: {
      type: Array
    },
    undergroundFloors: {
      type: Array
    },
    technicalLocals: {
      type: Array
    },
    floorboxs: {
      type: Array
    },
    columns: {
      type: Array
    },
    cableTypeSixOptions: {
      type: Array
    },
    cableTypeFiveOptions: {
      type: Array
    }
  },

  data() {
    return {
      floorboxFormIsOpen: false,
      itemToEdit: {
        data: null,
        index: null
      }
    }
  },

  computed: {
    /** Returns the headers of the table, depending on the type of the object */
    headers() {
      let headers = [];
      headers = [
          {
            text: '',
            align: 'start',
            sortable: false,
            width: '6%'
          },
          {
            text: this.$tc('Label',1),
            align: 'start',
            sortable: true,
            value: 'label',
            width: '22%',
          },
          {
            text: this.$t('Column'),
            align: 'start',
            sortable: true,
            value: 'column_uuid',
            width: '12%',
          },
          {
            text: this.$tc('Floor',1),
            align: 'start',
            sortable: true,
            value: 'floor_uuid',
            width: '14%',
          },
          {
            text: this.$t('Cable-inReference'),
            align: 'start',
            sortable: true,
            value: 'cable_in_material_id',
            width: '16%',
          },
          {
            text: this.$t('Active'),
            align: 'start',
            sortable: true,
            width: '14%'
          }
        ]
      if (!this.actionTypeIsView) {
        headers.push({
          text: null,
          align: 'end',
          sortable: true,
          value: 'addButton'
        })
      }
      return headers;
    },
    /** Indicates if the selected object is a floor */
    selectedObjectIsFloor() {
      return this.selectedObject && this.selectedObject.type === "Floor"
    },

    /** Indicates if the selected object is a column */
    selectedObjectIsColumn() {
      return this.selectedObject && this.selectedObject.type === "Column"
    },

    /** Indicates if the action type is 'view' */
    actionTypeIsView() {
      return this.actionType === 'view'
    }
  },

  methods: {
    ...mapActions(["UPDATE_SELECTED_OBJECT_DATA"]),
    /** Closes the delete dialog */
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    /** Emits an event to delete an item, based on its type and closes the delete dialog */
    deleteItem() {
      let eventName = null;
      let eventObject = null;
      if (this.selectedObjectIsFloor && this.itemToDelete.type === "Floor") {
        eventName = 'delete-floor';
        eventObject = {
          floorIndex: this.selectedObject.index
        }
      } else if (this.selectedObjectIsColumn && this.itemToDelete.type === 'Column') {
        eventName = 'delete-column';
        eventObject = {
          columnIndex: this.selectedObject.index
        }
      } else {
        eventName = 'delete-floorbox';
        eventObject = {
          columnUuid: this.itemToDelete.column_uuid,
          floorboxLabel: this.itemToDelete.label
        }
      }
      this.$emit(eventName, eventObject)
      this.closeDeleteDialog();
    },

    /** Sets the data of the item to edit and opens the dialog */
    editItem(item, index) {
      this.itemToEdit.data = item;
      this.itemToEdit.index = index;
      this.floorboxFormIsOpen = true;
    },

    /** Closes the creation dialog and clears the data */
    closefloorboxForm() {
      this.floorboxFormIsOpen = false;
      this.itemToEdit.data = null;
      this.itemToEdit.index = null;
    },
    /** Emits an event to save the object, based on its type, with its data and closes the dialog */
    saveObject(objectData) {
      this.$emit('save-floorbox', {
        data: objectData,
        index: this.itemToEdit.index
      });
      this.closefloorboxForm();
    },
    openDialog(){
      this.floorboxFormIsOpen = true;
    },
    getFloorNumber(floor_uuid){
      const floorNumber = this.getFloorIndex(floor_uuid, this.groundFloors, this.undergroundFloors);
      return `Floor ${floorNumber}`; 
    },
    getCableInReference(cableId){
      let cableLabel;
      this.cableTypeSixOptions.forEach(cable => {
        if(cable.id === cableId){
          cableLabel = cable.label;
        }
      });
      return cableLabel;
    },
    openFloorboxTab(item){
      this.UPDATE_SELECTED_OBJECT_DATA(item.closure);
      bus.$emit('open-floorbox');
    }
  }
}
</script>

<style>
.table-title {
  font-size: 14px;
  color: #929292
}

.floorbox-icon {
  width: 11px;
  height: 11px;
  border-radius: 2px;
  border: 1px grey solid;
}

.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  overflow: hidden;
}

.floorbox_label {
  display: flex;
  align-items: center;
  height: 25px !important;
}

.add-button {
  background-color: transparent !important;
  height: 20px !important;
  width: 15px;
  min-width: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FloorboxesTable.vue